/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SavedListPage} from '../models/SavedListPage';
import type {SavedListRequest} from '../models/SavedListRequest';
import type {SavedSearchPage} from '../models/SavedSearchPage';
import type {SavedSearchRequest} from '../models/SavedSearchRequest';

export interface GetMySavedLists$Request {
    userId: number;
    savedListRequest: SavedListRequest;
}

export interface GetMySavedLists$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMySavedListsRequest = createAction<PayloadData<void, GetMySavedLists$Request>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_LISTS__REQUEST');
export const getMySavedListsSuccess = createAction<PayloadData<SavedListPage, GetMySavedLists$Request>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_LISTS__SUCCESS');
export const getMySavedListsFailure = createAction<PayloadData<Error, GetMySavedLists$Request, true>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_LISTS__FAILURE');

export const getMySavedListsActions = [
    getMySavedListsRequest,
    getMySavedListsSuccess,
    getMySavedListsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SavedListRequest} meta.savedListRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMySavedLists = (meta: GetMySavedLists$Request, config?: GetMySavedLists$Config) => {
    return {
        CALL_API: {
            types: getMySavedListsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/my/saved-lists`,
            TRANSPORT_REQUEST_BODY: meta.savedListRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMySavedSearches$Request {
    userId: number;
    savedSearchRequest: SavedSearchRequest;
}

export interface GetMySavedSearches$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMySavedSearchesRequest = createAction<PayloadData<void, GetMySavedSearches$Request>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_SEARCHES__REQUEST');
export const getMySavedSearchesSuccess = createAction<PayloadData<SavedSearchPage, GetMySavedSearches$Request>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_SEARCHES__SUCCESS');
export const getMySavedSearchesFailure = createAction<PayloadData<Error, GetMySavedSearches$Request, true>>('SEARCH_SAVED_SEARCH__GET_MY_SAVED_SEARCHES__FAILURE');

export const getMySavedSearchesActions = [
    getMySavedSearchesRequest,
    getMySavedSearchesSuccess,
    getMySavedSearchesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SavedSearchRequest} meta.savedSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMySavedSearches = (meta: GetMySavedSearches$Request, config?: GetMySavedSearches$Config) => {
    return {
        CALL_API: {
            types: getMySavedSearchesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/my/saved-searches`,
            TRANSPORT_REQUEST_BODY: meta.savedSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSharedSavedLists$Request {
    userId: number;
    savedListRequest: SavedListRequest;
}

export interface GetSharedSavedLists$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSharedSavedListsRequest = createAction<PayloadData<void, GetSharedSavedLists$Request>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_LISTS__REQUEST');
export const getSharedSavedListsSuccess = createAction<PayloadData<SavedListPage, GetSharedSavedLists$Request>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_LISTS__SUCCESS');
export const getSharedSavedListsFailure = createAction<PayloadData<Error, GetSharedSavedLists$Request, true>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_LISTS__FAILURE');

export const getSharedSavedListsActions = [
    getSharedSavedListsRequest,
    getSharedSavedListsSuccess,
    getSharedSavedListsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SavedListRequest} meta.savedListRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSharedSavedLists = (meta: GetSharedSavedLists$Request, config?: GetSharedSavedLists$Config) => {
    return {
        CALL_API: {
            types: getSharedSavedListsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/shared/saved-lists`,
            TRANSPORT_REQUEST_BODY: meta.savedListRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSharedSavedSearches$Request {
    userId: number;
    savedSearchRequest: SavedSearchRequest;
}

export interface GetSharedSavedSearches$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSharedSavedSearchesRequest = createAction<PayloadData<void, GetSharedSavedSearches$Request>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_SEARCHES__REQUEST');
export const getSharedSavedSearchesSuccess = createAction<PayloadData<SavedSearchPage, GetSharedSavedSearches$Request>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_SEARCHES__SUCCESS');
export const getSharedSavedSearchesFailure = createAction<PayloadData<Error, GetSharedSavedSearches$Request, true>>('SEARCH_SAVED_SEARCH__GET_SHARED_SAVED_SEARCHES__FAILURE');

export const getSharedSavedSearchesActions = [
    getSharedSavedSearchesRequest,
    getSharedSavedSearchesSuccess,
    getSharedSavedSearchesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SavedSearchRequest} meta.savedSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSharedSavedSearches = (meta: GetSharedSavedSearches$Request, config?: GetSharedSavedSearches$Config) => {
    return {
        CALL_API: {
            types: getSharedSavedSearchesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/shared/saved-searches`,
            TRANSPORT_REQUEST_BODY: meta.savedSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

